'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024proto$0024$0024anon$0024184 from "./presto.types$proto$$anon$184.js";
import * as $j_presto$002etypes$0024proto$0024$0024anon$0024192 from "./presto.types$proto$$anon$192.js";
var $p;
/** @constructor */
function $c_Lpresto_types$proto$() {
  this.cdF = null;
  this.cdG = false;
  this.cdD = null;
  this.cdE = false;
}
export { $c_Lpresto_types$proto$ as $c_Lpresto_types$proto$ };
$p = $c_Lpresto_types$proto$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$proto$;
/** @constructor */
function $h_Lpresto_types$proto$() {
}
export { $h_Lpresto_types$proto$ as $h_Lpresto_types$proto$ };
$h_Lpresto_types$proto$.prototype = $p;
$p.cIm = (function() {
  if ((!this.cdG)) {
    this.cdF = new $j_presto$002etypes$0024proto$0024$0024anon$0024184.$c_Lpresto_types$proto$$anon$184(this);
    this.cdG = true;
  }
  return this.cdF;
});
$p.cIf = (function() {
  if ((!this.cdE)) {
    this.cdD = new $j_presto$002etypes$0024proto$0024$0024anon$0024192.$c_Lpresto_types$proto$$anon$192(this);
    this.cdE = true;
  }
  return this.cdD;
});
var $d_Lpresto_types$proto$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$proto$, "presto.types$proto$", ({
  a2J: 1
}));
export { $d_Lpresto_types$proto$ as $d_Lpresto_types$proto$ };
var $n_Lpresto_types$proto$;
function $m_Lpresto_types$proto$() {
  if ((!$n_Lpresto_types$proto$)) {
    $n_Lpresto_types$proto$ = new $c_Lpresto_types$proto$();
  }
  return $n_Lpresto_types$proto$;
}
export { $m_Lpresto_types$proto$ as $m_Lpresto_types$proto$ };
//# sourceMappingURL=presto.types$proto$.js.map
